"use strict";

(function() {
	angular.module('pphhApp')
		.controller("menuController", ["$scope", "$window", "CommonCatalogService", "pphhEnv", MenuController]);

	/**
	 * Controlador para gestionar los menús de la aplicación tanto en el ámbito público como
	 * en la parte privada.
	 */
	function MenuController($scope, $window, commonCatalogService, pphhEnv) {
		$scope.directives = [];

		$scope.init = init;
		$scope.gotoWaterModule = gotoWaterModule;
		$scope.gotoWaterModuleQueries = gotoWaterModuleQueries;
		$scope.areThereQueries = areThereQueries;
		$scope.changeLocale = changeLocale;

		function init() {
			commonCatalogService.getDirectives()
				.then(function(directiveArray) {
					angular.forEach(directiveArray, function(directive) {
						$scope.directives.push(directive);
					});
				});
		}

		function gotoWaterModule(waterModule) {
			var url = pphhEnv.global.contextPath + "/pphh-sgpusa-init?wm=" + waterModule.key;
			$scope.go(url);
		}

		function gotoWaterModuleQueries(waterModule) {
			var url = pphhEnv.global.contextPath + "/queries-init/" + waterModule.key;
			$scope.go(url);
		}

		$scope.go = function(url) {
			$window.location.href = url;
		};

		function areThereQueries(directive) {
			var found = false;
			angular.forEach(directive.modules, function(moduleObj) {
				found = found || moduleObj.userQueries;
			});

			return found;
		}

		function changeLocale(locale) {
			if (locale.match(/^[a-z]{2}$/) == null) {
				return;
			}

			var nextUrl = $window.location.href;
			if (nextUrl.match(/locale=[a-z]{2}/) == null) {
				if (nextUrl.indexOf("?") === -1) {
					nextUrl = nextUrl + "?";
				} else {
					nextUrl = nextUrl + "&";
				}

				nextUrl = nextUrl + "locale=" + locale
			} else {
				nextUrl = nextUrl.replace(/locale=[a-z]{2}/, "locale=" + locale);
			}

			$window.location.href = nextUrl;
		}
	}
})();